import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { compose } from 'redux'
import { withStyles } from '@material-ui/core'

import { routeIdSelector, shownRoutesSelector } from 'reduxModules/selectors/RouteSelectors'
import { departureTimeSelector } from 'reduxModules/selectors/BookSelectors'
import { dateSelector } from 'reduxModules/selectors/DateSelectors'
import { citiesRoutePriceSelector } from 'reduxModules/selectors/PriceSelectors'
import { routeActions } from 'reduxModules/actions/RouteActions'
import { fromCityTypeSelector } from 'reduxModules/selectors/CitySelectors'
import { isAlimanDispatcherSelector } from 'reduxModules/selectors/UserSelectors'

import { RouteButtonBase } from './RouteButton'

import { styles } from './styles'

const mapStateToProps = createStructuredSelector({
  date: dateSelector,
  routeId: routeIdSelector,
  shownRoutes: shownRoutesSelector,
  fromCityType: fromCityTypeSelector,
  departureTime: departureTimeSelector,
  citiesRoutePrice: citiesRoutePriceSelector,
  isAlimanDispatcher: isAlimanDispatcherSelector,
})

const mapDispatchToProps = {
  selectRoute: routeActions.selectRoute
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)

export const RouteButton = enhance(RouteButtonBase)



// WEBPACK FOOTER //
// ./src/components/RouteButton/index.js